import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// components
import SearchAndBrowsePageHeadline from "core/SearchAndBrowsePageHeadline";
import Avatar from "core/Avatar";

// styles
import { convertPxToRem } from "frontend/components/helpers";

const SearchAndBrowsePageHeadlineStyled = styled(SearchAndBrowsePageHeadline)`
    display: flex;
    align-items: center;
    gap: ${convertPxToRem(8)};
`;

const SearchAndBrowsePageHeadlineWithAvatar = ({
    className,
    children,
    creator = {},
    showSkeleton
}) => {
    return (
        <SearchAndBrowsePageHeadlineStyled
            showSkeleton={showSkeleton}
            className={className}
        >
            <Avatar user={creator} size={30} />
            <span>{children}</span>
        </SearchAndBrowsePageHeadlineStyled>
    );
};

export default SearchAndBrowsePageHeadlineWithAvatar;

SearchAndBrowsePageHeadlineWithAvatar.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    creator: PropTypes.object,
    showSkeleton: PropTypes.bool
};
